<!-- ══════════════════════════════════════════════
     GENERATE view
═══════════════════════════════════════════════ -->
<ng-container *ngIf="type === 'generate'">
  <div class="flx-modal" role="dialog" aria-modal="true">
 
    <div class="flx-modal__header">
      <h2>{{translate?.general.buttons.generate.singular}} {{translate?.document.label.singular}}</h2>
      <button class="icon-btn" aria-label="Close"
        [pTooltip]="translate?.general.buttons.close.singular"
        (click)="modalRef.hide()">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
 
    <div class="flx-modal__subheader">
      <h3>{{translate?.document.messages.selectTemplateToGenerate}}</h3>
    </div>
 
    <div class="flx-modal__body mp-body">
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.document.messages.selectTemplateToGenerate}}</label>
        <div class="field-row field-row--auto mb-1">
          <p-dropdown
            [filter]="true"
            placeholder="{{translate?.document.messages.selectTemplate}}"
            [options]="templatesData"
            optionLabel="templateName"
            optionValue="id"
            [(ngModel)]="pdfTemplates.templateId"
            [ngClass]="{'ng-invalid ng-dirty': generateSubmitted && !pdfTemplates.templateId}">
          </p-dropdown>
        </div>
        <div class="p-error text-10" *ngIf="generateSubmitted && !pdfTemplates.templateId">
            <span id="label_JobNoteReqField" *ngIf="generateSubmitted && !pdfTemplates.templateId">{{translate?.general.validationFE.requiredField}}</span>
         </div>

      </div>
      <div class="status-field">
        <label class="field-label">{{translate?.document.fields.notes.singular}}</label>
        <div class="field-row field-row--auto mb-2">
          <textarea pInputTextarea [(ngModel)]="pdfTemplates.notes" placeholder="Add a brief description of the reason for generation" [maxlength]="255"></textarea>
        </div>
      </div>
    </div>
 
    <div class="flx-modal__footer">
      <button type="button" class="custella-btn-white" (click)="modalRef.hide()">
        {{ translate?.general.buttons.cancel.singular }}
      </button>
      <p-button type="button" [label]="translate?.general.buttons.generate.singular" styleClass="h-32"
        (onClick)="onGenerate()">
      </p-button>
    </div>
 
  </div>
</ng-container>


<!-- ══════════════════════════════════════════════
     EMAIL view
═══════════════════════════════════════════════ -->
<ng-container *ngIf="type === 'email'">
  <div class="flx-modal" role="dialog" aria-modal="true">

    <!-- ── Header ── -->
    <div class="flx-modal__header">
      <h2>{{translate?.general.buttons.select2.singular}} {{translate?.document.fields.email.singular}} {{translate?.document.fields.recipient.plural}}</h2>
      <button class="icon-btn ms-auto" 
        [pTooltip]="translate?.general.buttons.close.singular"
        (click)="modalRef.hide()">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <div class="flx-modal__subheader">
      <h3>{{translate?.document.messages.selectRecipientsHint}}</h3>
    </div>

    <div class="flx-modal__body mp-body">

      <!-- To field -->
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.document.fields.to.singular}}</label>
        <div class="field-row field-row--auto mb-1">
          <p-dropdown 
                [options]="contactData" 
                [group]="true" 
                optionLabel="contactPersonName" 
                optionGroupLabel="valueName" 
                optionGroupChildren="modelFieldList" 
                placeholder="Select a recipient..." 
                [filter]="true" 
                filterBy="contactPersonName"
                (onChange)="selectContact($event)">
                <ng-template let-group pTemplate="group">
                    {{ group.valueName }}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    {{ item.contactPersonName }}
                </ng-template>
            </p-dropdown>
        </div>
        <small class="p-error" *ngIf="submitted && !selectedContact">
          {{translate?.general.validationFE.requiredField}}
        </small>
      </div>
      <!-- New Recipient inline card -->
      <div class="new-recipient-inline" *ngIf="showNewRecipient">

        <!-- <div class="status-field mt-2">
          <label class="field-label">Name</label>
          <div class="field-row field-row--auto mb-1">
            <input pInputText type="text"
              [(ngModel)]="newRecipientName"
              placeholder="Enter recipient name" />
          </div>
        </div> -->

        <div class="status-field">
          <label class="field-label mandatory">{{translate?.document.fields.email.singular}}</label>
          <div class="field-row field-row--auto mb-1">
            <input pInputText type="email"
              [(ngModel)]="newRecipientEmail"
              [ngClass]="{'ng-invalid ng-dirty': recipientSubmitted && !isValidEmail(newRecipientEmail)}"
              placeholder="Enter recipient email" />
          </div>
          <small class="p-error" *ngIf="recipientSubmitted && !newRecipientEmail.trim()">
            {{translate?.general.validationFE.requiredField}}
          </small>
          <small class="p-error" *ngIf="recipientSubmitted && newRecipientEmail.trim() && !isValidEmail(newRecipientEmail)">
            {{translate?.document.validationFE.invalidEmail}}
          </small>
        </div>

      </div>

      <!-- CC field -->
      <div class="status-field">
        <label class="field-label">{{translate?.document.fields.cc.singular}}</label>
        <div class="field-row field-row--auto mb-1">
          <textarea pInputTextarea
            [(ngModel)]="ccText"
            placeholder="Enter email addresses..."></textarea>
        </div>
        <small class="p-error" *ngIf="submitted && ccTooMany">
          {{translate?.document.validationFE.maxCCExceeded}}.
        </small>
        <small class="p-error" *ngIf="submitted && !ccTooMany && ccInvalid">
          {{translate?.document.validationFE.invalidCCEmail}}
        </small>
        <small class="form-hint" *ngIf="!submitted">Separate addresses with commas. Maximum 2.</small>
      </div>

    </div>

    <!-- ── Footer ── -->
    <div class="flx-modal__footer">

      <ng-container >
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">
          {{ translate?.general.buttons.cancel.singular }}
        </button>
         <!-- ✅ If new recipient form is open → save recipient first -->
        <p-button *ngIf="showNewRecipient"
          type="button"
          [label]="translate?.general.buttons.send.singular"
          styleClass="h-32"
          (onClick)="saveNewRecipient()">
        </p-button>

        <!-- ✅ If contact selected from dropdown → send directly -->
        <p-button *ngIf="!showNewRecipient"
          type="button"
          [label]="translate?.general.buttons.send.singular"
          styleClass="h-32"
          (onClick)="onSendEmail()">
        </p-button>
        
      </ng-container>

    </div>

  </div>
</ng-container>